// extracted by mini-css-extract-plugin
export var aboveInput = "_l9-0";
export var actionButton = "_l9-5";
export var actionButtonContainer = "_l9-1";
export var actionIcon = "_l9-6";
export var aiInfoContainer = "_l9-2";
export var attachmentWrapper = "_l9-7";
export var bold = "_l9-3";
export var checkIcon = "_l9-8";
export var clickingRecipientBar = "_l9-11";
export var commentThreadSwitch = "_l9-a";
export var draftImage = "_l9-b";
export var draftImageContainer = "_l9-c";
export var draftImages = "_l9-e";
export var editButton = "_l9-g";
export var editor = "_l9-f";
export var editorContainer = "_l9-y";
export var editorErrorTooltipWrapper = "_l9-9";
export var headerDivider = "_l9-h";
export var icon = "_l9-i";
export var info = "_l9-j";
export var internal = "_l9-n";
export var internalDivider = "_l9-k";
export var internalMessage = "_l9-l";
export var messageInputCard = "_l9-m";
export var messageInputForm = "_l9-o";
export var messageInputFormInternal = "_l9-p";
export var options = "_l9-q";
export var publicMessageCustomer = "_l9-s";
export var publicMessageMerchant = "_l9-r";
export var removeImageButton = "_l9-d";
export var replyButtons = "_l9-t";
export var showSignatureButton = "_l9-u";
export var spinner = "_l9-v";
export var verticalButtonDivider = "_l9-4";
export var visibilitySelector = "_l9-w";
export var warning = "_l9-x";
export var wrappingText = "_l9-z";
export var writingInternalNoteTopBorder = "_l9-10";